<template>
  <div id="sms-unstop-error-container">
    <MarkdownCopy :content="unstopErrorMessage" />
    <MarkdownCopy :content="$t.programText" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStaticGlobal } from '@garmin/vue-static-global';
import '@garmin/components-global-web/dist-web/components/GCopy';
import useSmsOptInStatusStore from '../store/smsOptInStatus';
import MarkdownCopy from './MarkdownCopy.vue';

const { translations } = useStaticGlobal();
const smsOptInStatusStore = useSmsOptInStatusStore();

defineOptions({
  name: 'SmsUnstopError',
});

const unstopErrorMessage = computed(() => {
  const { unstopCarrierNumber, unstopCarrierNumberNexmo } = translations;
  const source = smsOptInStatusStore.smsOptInStatus?.source?.toLowerCase?.();
  const unstopNumber = source === 'nexmo' ? unstopCarrierNumberNexmo : unstopCarrierNumber;

  return `${translations.unstopCarrierText} ${unstopNumber}`;
});
</script>
